module.exports = __webpack_public_path__ + "static/media/stock-adjustment.58d16cd5.svg";